// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__EgARG","icon":"loading_icon__SrZlt","spin":"loading_spin__-lu5O"};